import { NextPage } from 'next'
import Image from 'next/legacy/image'

import StoreLayout from './../components/StoreLayout'
import { t } from '../../../utils'

import StoreProductTabs, {
  StoreItemTypeEnum
} from './components/StoreProductTabs'
import StoreProductsBanner from './components/StoreProductsBanner'

import vocalsBannerImg from '@public/images/store/products_vocal_tracks_banner.png'
import vocalTracksImg from '@public/images/store/product-vocal-tracks.png'
import TryItBlock from '../components/TryItBlock'
import ProductsContent from './components/ProductsContent'

const StoreProductsVocals: NextPage & {
  theme?: string
} = () => {
  return (
    <StoreLayout
      pageTitle={t('Vocal Harmony Tracks & Stems - Worship Online')}
      pageDescription={t(
        'Download Vocal harmony multitracks for worship in any key. Take your vocal rehearsals to the next level!'
      )}
    >
      <StoreProductsBanner title={t('Vocal Tracks')}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="60"
          height="88"
          viewBox="0 0 60 88"
        >
          <g>
            <g>
              <g>
                <path
                  fill="#fff"
                  d="M29.92 71.598C13.764 71.598.623 58.455.623 42.303a3.022 3.022 0 1 1 6.044 0c0 12.82 10.429 23.251 23.251 23.251 12.819 0 23.25-10.43 23.25-23.251a3.022 3.022 0 1 1 6.043 0c0 16.152-13.14 29.295-29.293 29.295z"
                />
              </g>
              <g>
                <g>
                  <path
                    fill="#fff"
                    d="M43.592 20.369v22.12c0 7.54-6.134 13.674-13.673 13.674-7.54 0-13.674-6.135-13.674-13.675v-22.12c0-7.537 6.134-13.672 13.674-13.672 7.539 0 13.673 6.135 13.673 13.673zm6.043 22.12v-22.12C49.635 9.499 40.79.653 29.92.653c-10.872 0-19.718 8.846-19.718 19.716v22.12c0 10.871 8.846 19.717 19.718 19.717 10.87 0 19.716-8.846 19.716-19.718z"
                  />
                </g>
                <g>
                  <path
                    fill="#fff"
                    d="M23.245 29.12H13.223a3.022 3.022 0 1 1 0-6.044h10.022a3.023 3.023 0 0 1 0 6.044z"
                  />
                </g>
                <g>
                  <path
                    fill="#fff"
                    d="M23.245 39.783H13.223a3.022 3.022 0 1 1 0-6.044h10.022a3.023 3.023 0 0 1 0 6.044z"
                  />
                </g>
              </g>
              <g>
                <path
                  fill="#fff"
                  d="M29.92 87.347a3.022 3.022 0 0 1-3.022-3.022v-14.55a3.022 3.022 0 1 1 6.043 0v14.55a3.023 3.023 0 0 1-3.022 3.022z"
                />
              </g>
              <g>
                <path
                  fill="#fff"
                  d="M48.513 87.347h-37.19a3.023 3.023 0 0 1 0-6.043h37.19a3.023 3.023 0 0 1 0 6.043z"
                />
              </g>
            </g>
          </g>
        </svg>
        <Image
          src={vocalsBannerImg}
          alt={`Vocal Tracks background image`}
          priority={true}
          layout="fill"
          objectFit="cover"
        ></Image>
        <Image src={vocalTracksImg} alt="vocal tracks products" />
      </StoreProductsBanner>
      <ProductsContent>
        <p>
          {t(`Vocal Tracks are each of the vocal tracks found within a song.
          Including the practice piano track and click/guide track. These tracks
          come in 9 different keys per song!`)}
        </p>
        <p>
          {t(`There’s no better way to streamline your vocal rehearsals. Practice
          your part along with just the lead vocal, practice your lead part with
          only harmonies, or practice along with only the piano track. The
          possibilities are endless!`)}
        </p>
      </ProductsContent>
      <StoreProductTabs tab={StoreItemTypeEnum.VocalTracks} />
      <TryItBlock />
    </StoreLayout>
  )
}
StoreProductsVocals.theme = 'dark'
export default StoreProductsVocals
